import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'transferFunction';

export class TransferFunction extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
